import { render, staticRenderFns } from "./MechanicsAdd.vue?vue&type=template&id=33ca13ae&scoped=true"
import script from "./MechanicsAdd.vue?vue&type=script&lang=ts"
export * from "./MechanicsAdd.vue?vue&type=script&lang=ts"
import style0 from "./MechanicsAdd.vue?vue&type=style&index=0&id=33ca13ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca13ae",
  null
  
)

export default component.exports